﻿import $ from "jquery";
import { AppLog } from "./AppLog";

/**
 * Zeitraum-Auswahl im Auswertungsfilter (DEVCLR-315).
 *
 * Setzt die Datumsfelder auf die Grenzen der gewaehlten Option und sperrt sie, solange ein
 * dynamischer Zeitraum gilt. Die Grenzen liefert der Server je Option als data-von/data-bis mit -
 * hier wird nichts gerechnet, und maszgeblich ist ohnehin die Berechnung beim naechsten Post.
 *
 * Die Auswahl schickt das Formular NICHT ab (DEVCLR-315-Feedback): wie jede andere Filteraenderung
 * markiert der generische select-change-Handler der Gui (GuiAuswertung/GuiListAktion) das Ergebnis
 * nur als veraltet, der Benutzer muss auf "Aktualisieren" klicken. Der Wechsel zurueck auf "fester
 * Zeitraum" gibt die Felder frei - dort steht noch nicht fest, was der Benutzer eintragen will.
 *
 * Bewusst eine eigene Klasse per Komposition statt Vererbung, wie GuiFilterSort: die Auswertungen
 * und die Aktionsliste sind verschiedene Gui-Klassen, teilen sich aber das Partial
 * _auswertungFilter.cshtml. Gebunden wird deshalb auf dessen Container - das ist die Einheit, um
 * die es geht, und sie ist auch dann noch die richtige, wenn eine Seite ihr Formular umbaut.
 */
export class GuiFilterZeitraum {

    /** Wert von EnumZeitraum.Fest - dabei bleiben die Datumsfelder frei bedienbar. */
    private static readonly ZeitraumFest = "0";

    private readonly scope: JQuery;
    private readonly select: JQuery;

    constructor() {
        this.scope = $("#auswertungfilter");
        this.select = this.scope.find("select.zeitraum");

        // Auf der Aktionsliste wird der Filter nur bei aufgeklappter Suche gerendert.
        if (this.select.length === 0) {
            return;
        }

        AppLog.logInfo("GuiFilterZeitraum");

        this.select.on("change", () => this.apply());

        // Das X am Datumsfeld leert den Wert (GuiBase) - dazu passt nur der feste Zeitraum.
        this.scope.find("button.btn-date-remove").on("click", () => this.reset());

        // Startzustand: eine gespeicherte Auswertung kann mit dynamischem Zeitraum geladen sein.
        // Hier bewusst nur apply() - ein Absenden waere eine Endlosschleife.
        this.apply();
    }

    /** Uebernimmt die Grenzen der gewaehlten Option und sperrt die Felder entsprechend. */
    private apply() {
        const dynamisch = this.select.val() !== GuiFilterZeitraum.ZeitraumFest;

        if (dynamisch) {
            const option = this.select.find("option:selected");
            this.datumsfeld("Von").val(option.attr("data-von") ?? "");
            this.datumsfeld("Bis").val(option.attr("data-bis") ?? "");
        }

        this.sperren(dynamisch);
    }

    /** Zurueck auf festen Zeitraum. Die Felder werden frei, die Werte bleiben stehen. */
    private reset() {
        this.select.val(GuiFilterZeitraum.ZeitraumFest);
        this.sperren(false);
    }

    /**
     * readonly statt disabled: gesperrte Felder wuerden nicht mitgepostet, und der Sprung
     * "Aktionen (n)" arbeitet mit den geposteten Werten.
     */
    private sperren(gesperrt: boolean) {
        this.scope.find("input[type=date]")
            .prop("readonly", gesperrt)
            .toggleClass("erz-feld-gesperrt", gesperrt);
    }

    private datumsfeld(name: string): JQuery {
        return this.scope.find(`input[name='Filter.${name}']`);
    }
}
